export const MIN_LENGTH_OF_STAY_ON_ARRIVAL = '<date> requires a <days> night minimum stay';
export const MY_SEASON_PASS_GUESTS_INCLUDED = '<GUESTS> <GUESTS_PLURAL> Included';
